import React from 'react';
import { Card } from 'primereact/card';
import StarAttendanceRate from '../../assets/StarAttendanceRate.png';
import StarHW from '../../assets/StarHW.png';
import QuaTarget from '../../assets/QuaTarget.png';
import QuaMet from '../../assets/QuaMet.png';
import QuaNotMet from '../../assets/QuaNotMet.png';

interface MetricCardProps {
    label: string;
    value: string | number;
    target: string;
    qualifierMet: boolean;
    backgroundColor: string;
}

export const MetricCard = ({ label, value, target, qualifierMet, backgroundColor }: MetricCardProps) => {
    return (
        <Card className="shadow-md" style={{ width: '24%' }}>
            {/* Colored Header */}
            <div
                className="flex items-center p-2 gap-2"
                style={{ backgroundColor, display: 'flex', borderRadius: '20px', width: '220px' }}
            >
                <div className="justify-center">
                    <img
                        src={label?.includes('Attendance') ? StarAttendanceRate : StarHW}
                        style={{ width: '60px', height: '60px' }}
                        alt="icon"
                    />
                </div>

                {/* Label and Value */}
                <div>
                    <div className="font-semibold">{label}</div>
                    <div className="font-bold" style={{ fontSize: 'x-large' }}>
                        {value}
                    </div>
                </div>
            </div>

            <div className="mt-4 text-sm">
                <div className="mt-2">
                    <div className="text-blue-700 font-medium">
                        <img src={qualifierMet ? QuaMet : QuaNotMet} alt="targetArrow" />
                        &nbsp;{' '}
                        <span style={{ color: qualifierMet ? '#2AA154' : '#E23636' }}>
                            {' '}
                            {qualifierMet ? 'Qualifier Met' : 'Qualifier Not Met'}
                        </span>
                    </div>
                </div>
                <div className="text-blue-700 font-medium">
                    <img src={QuaTarget} alt="targetArrow" />
                    &nbsp; <span style={{ color: '#1A5AA5' }}> Target: {target}</span>
                </div>
            </div>
        </Card>
    );
};
